export default __webpack_public_path__ + "static/media/image_placeholder.3f4f51fe.jpg";